
export default function Skills() {
  return (
    <section id="skills" className="px-6 py-12 md:py-15 md:px-12 max-w-7xl mx-auto">
      <div className="space-y-4">
        <h2 className="text-3xl font-bold text-slate-900 tracking-tight">Technical Skills</h2>
        <div className="w-20 h-1 bg-[var(--accent-cyan)] rounded-full"></div>
      </div>
      <div className="mt-5 space-y-10">
        {/* Machine Learning Side */}
        <div>
          <h3 className="text-xl font-bold text-slate-900 mb-3">
            Machine Learning & AI
          </h3>

          <div className="space-y-2 text-sm">
            <p>
              <span className="font-semibold">Programming & Frameworks:</span>{" "}
              <span className="text-blue-600">
                Python, PyTorch, TensorFlow, Keras, Scikit-learn
              </span>
            </p>

            <p>
              <span className="font-semibold">Machine Learning:</span>{" "}
              Random Forest, XGBoost, LightGBM, PCA, Clustering, Feature Engineering, EDA
            </p>

            <p>
              <span className="font-semibold">Deep Learning:</span>{" "}
              ANN, CNN, RNN, LSTM, Encoder-Decoder Architectures
            </p>

            <p>
              <span className="font-semibold">Natural Language Processing:</span>{" "}
              Tokenization, Embeddings, Stemming & Lemmatization, Language Modeling, Text Classification,
              <span className="text-blue-600"> BERT, SpaCy, NLTK, LlamaIndex</span>
            </p>

            <p>
              <span className="font-semibold">Generative AI & LLMs:</span>{" "}
              <span className="text-blue-600">
                GPT, LangChain, RAG Pipelines, HuggingFace Transformers
              </span>
            </p>

            <p>
              <span className="font-semibold">Data Visualization:</span>{" "}
              Matplotlib, Seaborn
            </p>

            <p>
              <span className="font-semibold">Tools & Deployment:</span>{" "}
              MLflow, Kubeflow, Docker, AWS, Azure, Git/GitHub
            </p>
          </div>
        </div>

        {/* Web Engineering Side */}
        <div>
          <h3 className="text-xl font-bold text-slate-900 mb-3">
            Web Engineering
          </h3>

          <div className="space-y-2 text-sm">
            <p>
              <span className="font-semibold">Programming Languages:</span>{" "}
              <span className="text-blue-600">
                JavaScript, TypeScript, Go
              </span>
            </p>

            <p>
              <span className="font-semibold">Frontend:</span>{" "}
              <span className="text-blue-600">
                React.js, Next.js
              </span>
            </p>

            <p>
              <span className="font-semibold">Backend:</span>{" "}
              Node.js, Express.js, FastAPI, Flask, Golang
            </p>

            <p>
              <span className="font-semibold">Database:</span>{" "}
              MongoDB, MySql, Postgress
            </p>

            <p>
              <span className="font-semibold">Deployment:</span>{" "}
              AWS, Azure, GCP, Vercel
            </p>

            <p>
              <span className="font-semibold">Other Skills:</span>{" "}
              PostMan, git/github, Docker, Wordpress, Performance Optimization, Responsive Design, 
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
